/** A chip that opens the server's own sentence in a drawer - for text the server owns and a static
 * `infoText.ts` key cannot hold (a regime's in-force caveat, a support level's reason).
 *
 * The words are the server's, printed as they stand; closed, none of them is in the document, so the
 * text-budget guard does not count them as body text and a reader still finds them one press away.
 */

import { useState } from "react";

import { customerText } from "../../lib/customerWords";
import { Drawer } from "../../components/ui/Drawer";
import { StatusChip } from "../../components/ui/StatusChip";
import type { ChipTone } from "../../components/ui/StatusChip";
import styles from "./Filings.module.css";

export function ServerNote({
  label,
  exact,
  title,
  text,
  tone = "neutral",
  testId,
}: {
  /** The chip's words: the support level, "Enjoined". Said for a customer by the caller (`supportLevelWords`). */
  label: string;
  /** The exact words the server used, kept as the chip's title when `label` is a rewording of them. */
  exact?: string;
  /** The drawer's name. */
  title: string;
  /** The server's sentence. */
  text: string | null | undefined;
  tone?: ChipTone;
  testId?: string;
}) {
  const [open, setOpen] = useState(false);
  if (!text) {
    return (
      <StatusChip tone={tone} size="sm" testId={testId}>
        {label}
      </StatusChip>
    );
  }
  return (
    <>
      <button
        type="button"
        className={styles.chipButton}
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
        data-testid={testId}
        title={exact}
      >
        <StatusChip tone={tone} size="sm">
          {label}
        </StatusChip>
      </button>
      <Drawer open={open} onClose={() => setOpen(false)} title={title} width="sm">
        <p className={styles.note}>{customerText(text)}</p>
      </Drawer>
    </>
  );
}
